import { Link } from 'react-router-dom'
import SAISVG, { toAbsoluteUrl } from '../../../helpers/CommonFunction'
import { useLayout } from '../../core/LayoutProvider';
import clsx from 'clsx';

const SidebarLogo = () => {
  const {config} = useLayout()
  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  return (
    <div className='app-sidebar-logo px-6' id='sai_app_sidebar_logo'>
      <Link to='/agents'>
        <img
          alt='Logo'
          src={toAbsoluteUrl('truvoice_logo-new.png')}
          className='w-90 app-sidebar-logo-default'
        />
        <img
          alt='Logo'
          src={toAbsoluteUrl('truvoice-icon.png')}
          className='h-50px app-sidebar-logo-minimize'
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          id='sai_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            {active: appSidebarDefaultMinimizeDefault}
          )}
          data-sai-toggle='true'
          data-sai-toggle-state={toggleState}
          data-sai-toggle-target='body'
          data-sai-toggle-name={`app-sidebar-${toggleType}`}
        >
          <SAISVG path='media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export default SidebarLogo;